import { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { Dialog, DialogProps } from '@m/alchemy-ui/Dialog';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router';

const transitionDuration = 500;

const slideInRight = keyframes`
  from {
    transform: translate(100%);
  }
  to {
    transform: translate(0%);
  }
`;

const slideInLeft = keyframes`
  from {
    transform: translate(-100%);
  }
  to {
    transform: translate(0%);
  }
`;

const SidePanel = styled(Dialog)<{ attachedTo?: string }>`
  div[data-testid='DialogContents'] {
    transform: none;
    animation: ${transitionDuration}ms ${({ attachedTo }) =>
      (attachedTo === 'left' ? slideInLeft : slideInRight)} ease-out;
    transition: unset;
  }
  &[data-open='false'] div[data-testid='DialogContents'] {
    opacity: 1;
    transform: translate(${({ attachedTo }) =>
      (attachedTo === 'left' ? '-100%' : '100%')});
    transition: transform ${transitionDuration}ms ease-out;
  }
`;

export const AlchemySideModal = ({
  isOpen,
  onClose,
  closeOnBackNavigation = true,
  attachedTo = 'right',
  ...otherProps
}: DialogProps & { closeOnBackNavigation?: boolean }) => {
  const [visuallyOpen, setVisuallyOpen] = useState(isOpen);
  const history = useHistory();
  const location = useLocation();
  const closeModal = () => {
    setVisuallyOpen(false);
    setTimeout(() => {
      visuallyOpen && onClose?.();
    }, transitionDuration);
  };

  useEffect(() => setVisuallyOpen(isOpen), [isOpen]);
  useEffect(() => {
    if (closeOnBackNavigation && history.action === 'POP' && isOpen) {
      closeModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history, location]);

  return (
    <SidePanel
      data-testid="AlchemySideModal"
      data-open={`${visuallyOpen}`}
      isOpen={isOpen}
      onClose={closeModal}
      attachedTo={attachedTo}
      height="100vh"
      hasCloseIcon
      {...otherProps}
    />
  );
};
